import React, { useContext, useRef } from 'react'
import { Button, Field, Text, makeStyles, shorthands, tokens } from '@fluentui/react-components'
import { Add16Regular, Image20Regular, Dismiss16Regular, DocumentPdf20Regular, Document20Regular } from '@fluentui/react-icons'
import { t } from '../../../i18n/i18n'
import { UseFormReturn } from 'react-hook-form'
import { QuestionFormValues } from '../../../helpers/questionHelper'
import { Modal } from '../modal/Modal'
import { useBoolean } from '@fluentui/react-hooks'
import { DataContext } from '../../../App'
import { deleteAttachment, fileOnchange, getBlob } from '../../../helpers/fileHelper'

type FileInputProps = {
   label: string
   questionForm: UseFormReturn<QuestionFormValues>
   disabled: boolean
}
const useStyles = makeStyles({
   fileWrapper: {
      display: 'flex',
      alignItems: 'center',
      ...shorthands.gap(tokens.spacingHorizontalS),
   },
   contentStart: {
      justifyContent: 'start',
      fontWeight: tokens.fontWeightSemibold,
   },
   pointer: {
      cursor: 'pointer',
   },
   fontBold: {
      fontWeight: tokens.fontWeightSemibold,
   },
})
export const FileInput = ({ label, questionForm, disabled }: FileInputProps) => {
   const inputFile = useRef(null)

   const dataContext = useContext(DataContext)
   const { accessToken } = dataContext.state
   const [open, { setTrue: openDeleteAttachmentModal, setFalse: closeDeleteAttachmentModal }] = useBoolean(false)
   const classes = useStyles()

   const { setValue, watch } = questionForm
   const getIcon = (name: string): JSX.Element => {
      const type = name.substring(name.lastIndexOf('.') + 1)
      switch (type) {
         case 'png':
         case 'jpg':
         case 'jpeg':
            return <Image20Regular />
         case 'pdf':
            return <DocumentPdf20Regular />
         default:
            return <Document20Regular />
      }
   }
   return (
      <Field label={label} className={classes.fontBold}>
         <input type="file" ref={inputFile} style={{ display: 'none' }} onChange={(e) => fileOnchange(e, questionForm)} disabled={disabled} />
         {watch('selectedQuestion.attachment') ? (
            <span className={classes.fileWrapper}>
               {getIcon(watch('selectedQuestion.attachment.name'))}
               <Text onClick={async () => getBlob(questionForm, accessToken)} style={{ cursor: 'pointer' }}>
                  {watch('selectedQuestion.attachment.name')}
               </Text>
               {watch('selectedQuestion.attachment.id') ? (
                  <Dismiss16Regular onClick={openDeleteAttachmentModal} className={classes.pointer} color={tokens.colorPaletteRedForeground1} />
               ) : (
                  <Dismiss16Regular
                     onClick={() => {
                        setValue('selectedQuestion.attachment', null, { shouldDirty: true })
                        inputFile.current.value = ''
                     }}
                     className={classes.pointer}
                     color={tokens.colorPaletteRedForeground1}
                  />
               )}
            </span>
         ) : (
            <Button onClick={() => inputFile.current.click()} size="small" icon={<Add16Regular />} appearance="transparent" className={classes.contentStart}>
               {t('AddFile')}
            </Button>
         )}
         <Modal
            open={open}
            title={t('DeleteAttachment')}
            actions={
               <>
                  <Button
                     onClick={async () => deleteAttachment(questionForm, dataContext, closeDeleteAttachmentModal, inputFile)}
                     appearance="primary"
                     style={{ backgroundColor: tokens.colorStatusDangerForeground1 }}
                  >
                     {t('Delete')}
                  </Button>
                  <Button onClick={closeDeleteAttachmentModal}>{t('Cancel')}</Button>
               </>
            }
            children={t('DeleteAttachmentText')}
         />
      </Field>
   )
}
